import { useQuery } from '@tanstack/react-query';
import { getTags } from '@/lib/employees';

/**
 * Hook to fetch all available tags
 */
export function useTags() {
  return useQuery({
    queryKey: ['tags'],
    queryFn: getTags,
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
}
